import * as actions from "store/actions";

// Action Creators
export const emailTemplatesFetchedFromServer = (fetchedTemplatesResponse) => ({
  type: actions.EMAIL_TEMPLATES_FETCHED_FROM_SERVER,
  payload: fetchedTemplatesResponse,
});

export const emailTemplateSavedToServer = (templateId, templateBody) => ({
  type: actions.EMAIL_TEMPLATE_SAVED_TO_SERVER,
  payload: {
    id: templateId,
    body: templateBody,
  },
});

export const emailTemplatesInitialFetchCompleted = (templateData) => ({
  type: actions.EMAIL_TEMPLATES_INITIAL_FETCH_COMPLETED,
  payload: templateData,
});

export const emailTemplateSelectedInTabMenu = (templateId) => ({
  type: actions.EMAIL_TEMPLATE_SELECTED_IN_TAB_MENU,
  payload: templateId,
});

export const editorBodyModified = (body) => ({
  type: actions.EDITOR_BODY_MODIFIED,
  payload: body,
});

export const resetEmailTemplatesStore = () => ({
  type: actions.RESET,
});